module.exports = __webpack_public_path__ + "img/506bcfe.svg";